import * as Store from './Store';

const isProduction = process.env.NODE_ENV === 'production';

const i: any = function() {
  i.c(arguments);
};

i.q = [];
i.c = function(args: any) {
  i.q.push(args);
};

(window as any).Intercom = i;

const getScript = (source: string, callback: () => any) => {
  const script = document.createElement('script');
  script.async = true;
  script.type = 'text/javascript';
  document.getElementsByTagName('head')[0].appendChild(script);

  script.onload = (): any => {
    callback();
  };

  script.src = source;
};

export const Load = (appId: string, settings: Store.IntercomSettings) => {
  console.log('Loading Intercom');
  getScript('https://widget.intercom.io/widget/' + appId, () => {
    console.log('Intercom loaded');
    if (window['Intercom']) {
      window['Intercom']('boot', settings);
    }
  });
};

export const Update = (settings: Store.IntercomSettings) => {
  if (window['Intercom']) {
    window['Intercom']('update', settings);
  }
};

export const ShowMessages = (settings: Store.IntercomSettings) => {
  if (window['Intercom']) {
    window['Intercom']('showMessages', settings);
  }
};

export default Load;
